<template>
  <div class="Investment">
    <public-header></public-header>
    <div class="height70"></div>
    <div class="imt_banner">
      <div class="head_maintxt">
        <p class="head_maintxtp1">小城达人全国招商 火热招募中</p>
<!--        <p class="head_maintxtp2">此处是描述文本思密达</p>-->
        <div class="rz" @click="clikinto">点击入驻</div>
      </div>
    </div>
    <main id="HomesMain">
      <div class="main_top">
        <div class="main_toptxt">
          <p class="maintxt">小城达人-总部服务</p>
          <p class="maintxt2">加入小城达人，总部对加盟商扶持</p>
        </div>
        <div class="main_top_list">
          <ul>
            <li>
              <div>
                <img src="../../assets/qw/item_js.png" alt />
              </div>
              <p>技术支持</p>
              <span>小城产品研发团队7*24小时，即时响应</span>
            </li>
            <li>
              <div>
                <img src="../../assets/qw/item_tg.png" alt />
              </div>
              <p>推广支持</p>
              <span>新媒体、朋友圈、公众号、峰会、广告全维度推广支持</span>
            </li>
            <li>
              <div>
                <img src="../../assets/qw/item_px.png" alt />
              </div>
              <p>培训支持</p>
              <span>线上线下培训临时指导，实时交流</span>
            </li>
            <li>
              <div>
                <img src="../../assets/qw/item_wl.png" alt />
              </div>
              <p>物料支持</p>
              <span>统一企业对外形象，市场推广物料支持</span>
            </li>
            <li>
              <div>
                <img src="../../assets/qw/item_fw.png" alt />
              </div>
              <p>服务支持</p>
              <span>渠道商设有专人商务小组实时跟进，持续服务</span>
            </li>
            <li>
              <div>
                <img src="../../assets/qw/item_zy.png" alt />
              </div>
              <p>资源支持</p>
              <span>3000万存量用户渠道商市场启动</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="main_cen">
        <div class="main_toptxt">
          <p class="maintxt">合作优势</p>
        </div>
        <div class="main_cen_list">
          <ul>
            <li>
              <div class="main_cen_item">
                <div class="main_cen_item_img">
                  <img src="../../assets/qw/item_zz.png" alt />
                </div>
                <div class="main_cen_item_txt">
                  <p>营销增长</p>
                  <span>助力企业建立从理论到实践落地的“数据驱动增长体系”，真正实现超级增长</span>
                </div>
              </div>
            </li>
            <li>
              <div class="main_cen_item">
                <div class="main_cen_item_img">
                  <img src="../../assets/qw/item_sq.png" alt />
                </div>
                <div class="main_cen_item_txt">
                  <p>社群化推广</p>
                  <span>在网络社区营销及社会化媒体营销基础上发展起来的用户连接及交流更为紧密的网络营销方式</span>
                </div>
              </div>
            </li>
            <li>
              <div class="main_cen_item">
                <div class="main_cen_item_img">
                  <img src="../../assets/qw/item_dr.png" alt />
                </div>
                <div class="main_cen_item_txt">
                  <p>达人激励</p>
                  <span>拉新激励与完成任务激励，增大达人接单积极性</span>
                </div>
              </div>
            </li>
            <li>
              <div class="main_cen_item">
                <div class="main_cen_item_img">
                  <img src="../../assets/qw/item_fz.png" alt />
                </div>
                <div class="main_cen_item_txt">
                  <p>流量赋值</p>
                  <span>技术赋能企业，精准利用个人流量传播</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="main_bom">
        <div class="main_bomtxt">
          <p class="maintxt">小城合作企业申请流程</p>
          <span>流程一步步走，流量大幅上涨</span>
        </div>
        <div class="main_bom_list">
          <i></i>
          <ul>
            <li>
              <div class="main_bom_item_img">
                <img src="../../assets/qw/hz_sq.png" alt />
              </div>
              <div class="triangle"></div>
              <p>填写资料</p>
            </li>
            <li>
              <div class="main_bom_item_img">
                <img src="../../assets/qw/hz_cz.png" alt />
              </div>
              <div class="triangle"></div>
              <p>线下核实</p>
            </li>
            <li>
              <div class="main_bom_item_img">
                <img src="../../assets/qw/hz_cg.png" alt />
              </div>
              <div class="triangle2"></div>
              <p>认证完成</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="main_user" >
        <div class="main_user_txt">
          <p>申请加入，我们会第一时间联系您</p>
          <span>期待你的加入喔</span>
        </div>
        <div class="main_user_item">

          <el-form ref="form" :model="form" label-width="20px">
            <el-input v-model="form.name" placeholder="公司名称"></el-input>
            <el-input v-model="form.nickname" placeholder="您的称呼"></el-input>
            <el-input v-model="form.telephone"  placeholder="电话号码"></el-input>
            <el-input v-model="form.area"  placeholder="意向加盟信息"></el-input>
          </el-form>
        </div>
        <!-- <el-button class="main_item_button main_item_buttonleft" @click="dialogVisible">取消</el-button> -->
        <el-button class="main_item_button" type="warning" @click="handelJoin">提交</el-button>
      </div>
    </main>
    <public-footer></public-footer>
    <back-top></back-top>
  </div>
</template>

<script>
    // import axios from 'axios';
    import PublicHeader from '@/components/PublicHeader.vue'
    import {addBusiness} from '@/config/api.js'
    import PublicFooter from "@/components/PublicFooter.vue";
    import BackTop from "@/components/BackTop.vue";
export default {
  name: "Investment",
  components:{
    PublicHeader,
    PublicFooter,
    BackTop
  },
  data() {
    return {
      dialogService:false,
      // dialogVisible:false,
      form: {
                    name: '',
                    nickname: '',
                    telephone: '',
                    area: ''
                },
    };
  },
  methods: {
    clikinto(){
      document.documentElement.scrollTop=3300;//不需要加单位
    },
    handelJoin() {
      let data = {
        name: this.form.name,
        nickname: this.form.nickname,
        telephone: this.form.telephone,
        area: this.form.area
      };
      this.$post(addBusiness, data)
        .then(() => {
          setTimeout(() => {
            this.$message.success(
              "提交成功，我们会有工作人员与您联系，请保持电话畅通"
            );
            this.dialogVisible();
          }, 1000);
        })
        .catch(err => {
          window.console.log(err);
          setTimeout(() => {
            this.$message.error("提交失败，请重新提交");
          }, 100);
        });
    },
    dialogVisible(){
      this.form.name = '';
      this.form.nickname = '';
      this.form.telephone = '';
      this.form.area = ''
    }
  },
};
</script>

<style scoped>
/* .NewHomeNav .NewHome_top{
  background: none;
}
.imt_banner .NewHomeNav .NewHome_top{
  background: none !important;
}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right li span{color: #ffffff}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right .hovf9:hover{
  background: none;
} */
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right .hovf9:hover{
  background: none;

}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right .hovf7:hover{
  background: none;

}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right li span{
    transition: all .7s;
  border-bottom: 3px solid #FF7B26;
  color: #fff;
}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right .hovf9:hover span{

  color: #ffffff ;
}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right li:hover span{
  border-bottom: 3px solid #ffffff;
}
.imt_banner .NewHomeNav .NewHome_top .NewHome_top_container .NewHome_right li:hover{
  background: none;

}

p,span,a,div,i {
  }
  .iconfont {
    width: 20px;
    height: 20px;
    color: #ffffff;
  }
  a {
    text-decoration: none;
    color: #333;
  }
  ul,
  li {
    list-style: none;
  }
  #Home_head {
    position: relative;
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .imt_banner {
    /* margin-top: 1px; */
    overflow: hidden;
    z-index: -1;
    background: url("../../assets/qw/banner.png") 0 0;
    width: 100%;
    height: 670px;
  }
  #Home_head .head_ln {
    width: 1200px;
    height: 70px;
  }
  #Home_head .head_ln .head_lg {
    float: left;
    width: 134.65px;
    height: 32px;
    margin-top: 19px;
    /* box-shadow:0px 0px 20px rgba(237,237,237,1); */
  }
  #Home_head .head_ln .head_lg img {
    width: 134.65px;
    height: 32px;
  }
  #Home_head .head_ln .head_nav {
    float: right;
  }
  #Home_head .head_ln .head_nav .head_nav_list li {
    position: relative;
    float: left;
    width: 135px;
    height: 70px;
    padding-top: 24px;
    text-align: center;
    transition:2s;
  }
  #Home_head .head_ln .head_nav .head_nav_list li p {
    height: 21px;
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
  }
  #Home_head .head_ln .head_nav .head_nav_list span {
    width: 30px;
    height: 3px;
    background: #ffffff;
    text-align: center;
    margin-bottom: -2px;
    display: inline-block;
    opacity: 0;
  }
  #Home_head .head_ln .head_nav .head_nav_list li:hover span{
    opacity:1;
    transition: opacity .7s
}
  .head_maintxt {
    overflow: hidden;
    text-align: center;
    margin-top: 224px;
  }
  .head_maintxtp1 {
    height: 79px;
    font-size: 60px;
    font-weight: bold;
    line-height: 56px;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
  }
  .head_maintxtp2 {
    /* width:220px; */
    height: 28px;
    font-size: 22px;
    line-height: 18px;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
  }
  .Investment .head_maintxt .rz {
    cursor: pointer;
    width: 160px;
    height: 50px;
    background: #ffffff;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    color: #ff741f;
    margin-top: 71px;
    display: inline-block;
    border-radius: 6px;
  }
  #HomesMain {
    margin-bottom: 160px;
  }
  #HomesMain .main_top .main_toptxt {
    margin-top: 160px;
    margin-bottom: 80px;
    text-align: center;
  }
  #HomesMain .main_top .maintxt {
    height: 35px;
    font-size: 26px;
    font-weight: bold;
    line-height: 35px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
    margin-bottom: 10pt;
  }
  #HomesMain {
    position: relative;
  }
  #HomesMain .main_top .maintxt2 {
    height: 18px;
    font-size: 14px;
    line-height: 18px;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }
  #HomesMain .main_top .main_top_list {
    width: 1200px;
    height: 790px;
    margin: auto;
  }
  #HomesMain .main_top .main_top_list ul {
    /* border: 1px solid #000; */
    width: 1200px;
    height: 790px;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
    justify-content: space-between;
  }
  #HomesMain .main_top .main_top_list ul li {
    border-radius: 20px;
    width: 380px;
    height: 380px;
    /* border: 1px solid #ff741f; */
    box-shadow:0px 0px 20px rgba(237,237,237,1);
    padding-top: 65px;
  }
  #HomesMain .main_top .main_top_list ul li div {
    width: 160px;
    height: 160px;
    margin: auto;
  }
  #HomesMain .main_top .main_top_list ul li img {
    width: 160px;
    height: 160px;
  }
  #HomesMain .main_top .main_top_list ul li p {
    margin: 10px auto 0 auto;
    width: 80px;
    height: 26px;
    font-size: 20px;
    font-weight: bold;
    line-height: 26px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
  }
  #HomesMain .main_top .main_top_list ul li span {
    margin: 15px auto 0 auto;
    text-align: center;
    display: block;
    width: 208px;
    height: 40px;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }
  #HomesMain .main_cen {
    margin-top: 200px;
  }
  #HomesMain .main_cen .main_toptxt {
    width: 104px;
    height: 35px;
    margin: auto;
  }
  #HomesMain .main_cen .main_toptxt .maintxt {
    width: 104px;
    height: 35px;
    font-size: 26px;
    font-weight: bold;
    line-height: 35px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
  }
  #HomesMain .main_cen .main_cen_list {
    width: 1200px;
    height: 640px;
    margin: auto;
    margin-top: 60px;
  }
  #HomesMain .main_cen .main_cen_list ul {
    background: #FCFDFE;
    border-radius:20px;
    width: 1200px;
    height: 640px;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
    justify-content: space-between;
  }
  #HomesMain .main_cen .main_cen_list li {
    width: 600px;
    height: 320px;
    /* border: 1px solid #000000; */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item {
    width: 390px;
    height: 160px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item_img {
    width: 160px;
    height: 160px;
    margin-right: 30px;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item_img img {
    width: 160px;
    height: 160px;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item_txt {
    width: 200px;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item_txt p {
    height: 25px;
    font-size: 20px;
    line-height: 26px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
    margin-bottom:20px;
  }
  #HomesMain .main_cen .main_cen_list li .main_cen_item_txt span {
    width: 200px;
    height: 44px;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(153, 153, 153, 1);
    opacity: 1;
  }
  #HomesMain .main_bom {
    margin-top: 200px;
  }
  #HomesMain .main_bom .main_bomtxt {
    text-align: center;
  }
  #HomesMain .main_bom .main_bomtxt p {
    margin: auto;
    width: 260px;
    height: 35px;
    font-size: 26px;
    font-weight: bold;
    line-height: 35px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
    margin-bottom: 10pt;
  }
  #HomesMain .main_bom .main_bomtxt span {
    width: 140px;
    height: 18px;
    font-size: 14px;
    line-height: 18px;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }
  #HomesMain .main_bom .main_bom_list {
    position: relative;
    margin: 120px auto 0 auto;
    width: 820px;
    height: 200px;
  }
  #HomesMain .main_bom .main_bom_list i {
    position: absolute;
    top: 147px;
    left: 54px;
    width: 711px;
    height: 2px;
    background: rgba(246, 246, 246, 1);
    opacity: 1;
  }
  #HomesMain .main_bom .main_bom_list ul {
    width: 820px;
    height: 200px;
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  #HomesMain .main_bom .main_bom_list ul li {
    width: 120px;
    height: 200px;
    position: relative;
  }
  #HomesMain .main_bom .main_bom_list ul li .main_bom_item_img {
    width: 120px;
    height: 120px;
  }
  #HomesMain .main_bom .main_bom_list ul li .triangle{
    position: absolute;
    left:50%;
    margin-left: -7px;
    top: 139px;
    width: 14px;
    height: 15px;
    background:url('../../assets/images/triangle.png') 0 0 no-repeat;
  }
   #HomesMain .main_bom .main_bom_list ul li .triangle2{
     position: absolute;
    left:50%;
    margin-left: -7px;
    top: 139px;
    width: 14px;
    height: 15px;
    background:url('../../assets/images/triangle2.png') 0 0 no-repeat;
   }
  #HomesMain .main_bom .main_bom_list ul li .main_bom_item_img img {
    width: 120px;
    height: 120px;
  }
  #HomesMain .main_bom .main_bom_list ul li p {
    margin: auto;
    margin-top: 55px;
    width: 80px;
    height: 25px;
    font-size: 20px;
    line-height: 26px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
  }
  #HomesMain .main_user {
    margin: auto;
    margin-top: 200px;
    width: 1200px;
    height: 547px;
    padding-top: 60px;
    border:1px solid rgba(235,235,235,1);
  }
  #HomesMain .main_user .main_user_txt {
    text-align: center;
  }
  #HomesMain .main_user .main_user_txt p {
    margin: auto;
    width: 390px;
    height: 35px;
    font-size: 26px;
    font-weight: bold;
    line-height: 35px;
    color: rgba(41, 41, 41, 1);
    opacity: 1;
    margin-bottom: 10pt
  }
  #HomesMain .main_user .main_user_txt span {
    width: 140px;
    text-align: center;
    height: 18px;
    font-size: 14px;
    line-height: 18px;
    color: rgba(102, 102, 102, 1);
    opacity: 1;
  }
  #HomesMain .main_user .main_user_item {
    /* border: 1px solid #000000; */
    margin: auto;
    margin-top: 30px;
    height: 230px;
    width: 360px;
    display: flex;
    flex: 1;
    justify-content: space-between;

  }
  #HomesMain .main_user .main_user_item div {
    width: 360px;
    height: 50px;
    margin-top: 10px;
  }
  #HomesMain .main_user .main_user_item div input {
    outline: none;
    margin-top: 10px;
    width: 360px;
    height: 50px;
    font-size: 14px;
    font-weight: 400;
    opacity: 1;
  }
  #HomesMain .main_user{
      text-align: center;
  }
  #HomesMain .main_user .main_item_button{
    margin-top: 60px;
        background: #FE9539;
        width: 160px;
        height: 50px;
  }
#HomesMain .main_user .main_item_buttonleft{
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  width: 92px;
    margin-right: 21px;

}
</style>
